/**
 * Badge « non lu » — compteur dérivé (comparaison de deux horodatages), pas de
 * table de lecture par message. `role` = celui de l'utilisateur courant dans
 * CETTE discussion (nécessairement 'tutor' ou 'student', une discussion est
 * strictement 1 tuteur + 1 élève).
 */

import type { DiscussionRow } from './types';

export type DiscussionViewerRole = 'tutor' | 'student';

function lastReadAt(discussion: DiscussionRow, role: DiscussionViewerRole): string | null {
  return role === 'tutor' ? discussion.lastReadAtTutor : discussion.lastReadAtStudent;
}

/** Vrai si CE rôle a des messages non lus dans cette discussion. */
export function hasUnreadDiscussion(
  discussion: DiscussionRow,
  role: DiscussionViewerRole,
): boolean {
  const readAt = lastReadAt(discussion, role);
  if (readAt === null) return true;
  return discussion.lastMessageAt > readAt;
}

/** Nombre de discussions non lues dans une liste (badge global de nav). */
export function countUnreadDiscussions(
  discussions: readonly DiscussionRow[],
  role: DiscussionViewerRole,
): number {
  return discussions.filter((d) => hasUnreadDiscussion(d, role)).length;
}
